import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowParams,
} from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { EsiFeeScheduleType } from '../../types';
import { formatCurrency } from '../../utils/currency-helpers';

interface UseEsiFeeScheduleColumnsProps {
  onEdit: (row: EsiFeeScheduleType) => void;
  onDelete: (row: EsiFeeScheduleType) => void;
  canWrite: boolean;
}

export const useEsiFeeScheduleColumns = ({
  onEdit,
  onDelete,
  canWrite,
}: UseEsiFeeScheduleColumnsProps): GridColDef[] =>
  useMemo(
    () => [
      {
        field: 'upc',
        headerName: 'UPC',
        width: 150,
        valueFormatter: (params): string => params.value ?? '--',
      },
      {
        field: 'program',
        headerName: 'Program',
        width: 130,
        valueFormatter: (params): string => params.value ?? '--',
      },
      {
        field: 'paymentType',
        headerName: 'Payment Type',
        width: 140,
        valueFormatter: (params): string => params.value ?? '--',
      },
      {
        field: 'price',
        headerName: 'Price',
        width: 120,
        renderCell: (
          params: GridRenderCellParams<EsiFeeScheduleType>,
        ): string =>
          isNaN(params.row.price)
            ? '--'
            : formatCurrency(params.row.price, 'USD', true),
      },
      {
        field: 'description',
        headerName: 'Description',
        flex: 1,
        minWidth: 200,
      },
      ...(canWrite
        ? [
            {
              field: 'actions',
              headerName: 'Actions',
              type: 'actions',
              width: 100,
              getActions: (
                params: GridRowParams<EsiFeeScheduleType>,
              ): JSX.Element[] => [
                <GridActionsCellItem
                  key={`edit-${params.id}`}
                  icon={<EditIcon />}
                  label="Edit"
                  onClick={(): void => onEdit(params.row)}
                />,
                <GridActionsCellItem
                  key={`delete-${params.id}`}
                  icon={<DeleteOutlineIcon />}
                  label="Delete"
                  onClick={(): void => onDelete(params.row)}
                />,
              ],
            },
          ]
        : []),
    ],
    [onEdit, onDelete, canWrite],
  );
